module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticClass: "abbre",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("ASV")]), _vm._v(" "), _c('td', [_vm._v("American Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")])]), _vm._v(" "), _c('td', [_vm._v("before Common Era")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CEB")]), _vm._v(" "), _c('td', [_vm._v("Common English Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("CEV")]), _vm._v(" "), _c('td', [_vm._v("Common English Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("cf.")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("confer")]), _vm._v(", compare")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ch.")]), _vm._v(" "), _c('td', [_vm._v("chapter")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("chs.")]), _vm._v(" "), _c('td', [_vm._v("chapters")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("e.g.")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("exempli gratia")]), _vm._v(", for example")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ERV")]), _vm._v(" "), _c('td', [_vm._v("Easy-to-Read Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("ESV")]), _vm._v(" "), _c('td', [_vm._v("English Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("etc.")]), _vm._v(" "), _c('td', [_c('i', [_vm._v("et cetera,")]), _vm._v(" and so forth, and the rest")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("HCSB")]), _vm._v(" "), _c('td', [_vm._v("Holman Christian Standard Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("KJV")]), _vm._v(" "), _c('td', [_vm._v("King James Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("lit.")]), _vm._v(" "), _c('td', [_vm._v("literally")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("MEV")]), _vm._v(" "), _c('td', [_vm._v("Modern English Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NASB")]), _vm._v(" "), _c('td', [_vm._v("New American Standard Bible")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NCV")]), _vm._v(" "), _c('td', [_vm._v("New Century Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIV")]), _vm._v(" "), _c('td', [_vm._v("New International Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NJPS")]), _vm._v(" "), _c('td', [_vm._v("New Jewish Publication Society Translation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NLT")]), _vm._v(" "), _c('td', [_vm._v("New Living Translation")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NRSV")]), _vm._v(" "), _c('td', [_vm._v("New Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RSV")]), _vm._v(" "), _c('td', [_vm._v("Revised Standard Version")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("v.")]), _vm._v(" "), _c('td', [_vm._v("verse")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("vv.")]), _vm._v(" "), _c('td', [_vm._v("verses")])])])]), _vm._v(" "), _c('p', {
    staticClass: "H1b"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE BOOKS OF THE OLD TESTAMENT")])]), _vm._v(" "), _c('table', {
    staticClass: "Table2",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_vm._v("Genesis")])]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Gen.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Exodus")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Exod.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Leviticus")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Lev.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Numbers")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Num.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Deuteronomy")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Deut.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Joshua")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Josh.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Judges")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Judg.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Ruth")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Ruth")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1–2 Samuel")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("1–2 Sam.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1–2 Kings")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("1–2 Kgs.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1–2 Chronicles")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("1–2 Chr.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Ezra")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Ezra")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Nehemiah")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Neh.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Esther")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Esther")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Job")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Job")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Psalms")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Ps. (plural Pss.)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Proverbs")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Prov.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Ecclesiastes")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Eccl.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Song of Songs")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Song")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Isaiah")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Isa.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Jeremiah")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Jer.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Lamentations")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Lam.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Ezekiel")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Ezek.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Daniel")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Dan.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Hosea")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Hosea")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Joel")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Joel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Amos")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Amos")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Obadiah")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Obad.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Jonah")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Jonah")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Micah")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Mic.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Nahum")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Nah.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Habakkuk")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Hab.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Zephaniah")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Zeph.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Haggai")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Hag.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Zechariah")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Zech.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Malachi")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Mal.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "H1b"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE BOOKS OF THE NEW TESTAMENT")])]), _vm._v(" "), _c('table', {
    staticClass: "Table2",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Matthew")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Matt.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Mark")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Mark")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Luke")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Luke")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("John")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("John")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Acts")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Acts")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Romans")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Rom.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1–2 Corinthians")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("1–2 Cor.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Galatians")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Gal.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Ephesians")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Eph.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Philippians")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Phil.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Colossians")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Col.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1–2 Thessalonians")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("1–2 Thess.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1–2 Timothy")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("1–2 Tim.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Titus")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Titus")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Philemon")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Phlm.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Hebrews")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Heb.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("James")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Jas.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1–2 Peter")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("1–2 Pet.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("1, 2, 3 John")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("1, 2, 3 John")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Jude")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Jude")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdleft"
  }, [_vm._v("Revelation")]), _vm._v(" "), _c('td', {
    staticClass: "tdleft1"
  }, [_vm._v("Rev.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847bb512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviations.vue
// module id = 78
// module chunks = 0